var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.833496,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "#F6851B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10156 10.7C6.10156 10.2582 6.45974 9.9 6.90156 9.9H7.10156C7.54339 9.9 7.90156 10.2582 7.90156 10.7C7.90156 11.1418 7.54339 11.5 7.10156 11.5H6.90156C6.45974 11.5 6.10156 11.1418 6.10156 10.7ZM6.10156 4.4C6.10156 3.90294 6.50451 3.5 7.00156 3.5C7.49862 3.5 7.90156 3.90294 7.90156 4.4V7.4C7.90156 7.89706 7.49862 8.3 7.00156 8.3C6.50451 8.3 6.10156 7.89706 6.10156 7.4V4.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningOrange);
export default __webpack_public_path__ + "static/media/icon-warning-orange.78a85feaa1f3a8fdcec3f14430413b64.svg";
export { ForwardRef as ReactComponent };